import { WsOperationMessageContent } from '@/ws/notifiers/job-operation';
import {
  WsCaseEventMessageContent,
  WsCaseGroundTripEventMessageContent,
  WsCaseRouteEventMessageContent,
} from '@/ws/notifiers/case';
import { WsAllCasesEventMessageContent } from '@/ws/notifiers/cases-board';
import { WsBulkAssignmentMessageContent } from '@/ws/notifiers/bulk-assignment';
import { WsIdentitySyncFailedMessageContent } from '@/ws/notifiers/identity-sync';

export enum WsMessageOperationType {
  OPERATION_FINISHED = 'OPERATION_FINISHED',
}

export enum WsMessageIdentitySyncType {
  IDENTITY_SYNC_FAILED = 'IDENTITY_SYNC_FAILED',
}

export enum WsMessageCaseType {
  CASE_EVENT_CREATED = 'CASE_EVENT_CREATED',
  MAO_TRIP_UPDATE = 'MAO_TRIP_UPDATE',
  ROUTE_CREATED_EVENT = 'ROUTE_CREATED_EVENT',
  LEGS_UPDATED_EVENT = 'LEGS_UPDATED_EVENT',
  TOAST_CASE_EVENT_CREATED = 'TOAST_CASE_EVENT_CREATED',
}

export enum WsMessageAllCasesType {
  CaseUpdated = 'CaseUpdated', // Used for Cases Board updates
}

export enum WsMessageRouteType {
  RouteChanged = 'RouteChanged', // Used for Route updates
}

export enum WsMessageGroundTripType {
  GroundTripUpdated = 'GroundTripUpdated', // Used for Route updates
}

export enum WsMessageBulkAssignmentType {
  BulkOperationStatus = 'BulkOperationStatus',
}

export type WsGeneralMessageContent =
  | WsOperationMessageContent
  | WsCaseEventMessageContent
  | WsMessageAllCasesType
  | WsCaseRouteEventMessageContent
  | WsBulkAssignmentMessageContent;

export type WsSubscriptionMethod = {
  (type: WsMessageOperationType, content: WsOperationMessageContent, notificationAuthorUserId: string): void;
  (type: WsMessageCaseType, content: WsCaseEventMessageContent, notificationAuthorUserId: string): void;
  (type: WsMessageAllCasesType, content: WsAllCasesEventMessageContent, notificationAuthorUserId: ''): void;
  (type: WsMessageRouteType, content: WsCaseRouteEventMessageContent, notificationAuthorUserId: ''): void;
  (type: WsMessageBulkAssignmentType, content: WsBulkAssignmentMessageContent, notificationAuthorUserId: string): void;
  (type: WsMessageGroundTripType, content: WsCaseGroundTripEventMessageContent, notificationAuthorUserId: string): void;
  (
    type: WsMessageIdentitySyncType,
    content: WsIdentitySyncFailedMessageContent,
    notificationAuthorUserId: string,
  ): void;
};

export type WsConnectionStatus = 'connecting' | 'connected' | 'reconnecting' | 'disconnected';

export const RECEIVE_MESSAGE_METHOD_NAME = 'ReceiveMessage';

export abstract class AbstractWsConnector {
  abstract start(): Promise<void>;
  abstract on(handler: WsSubscriptionMethod): () => void;
  abstract off(handler?: WsSubscriptionMethod): void;
  abstract invoke(eventName: string, ...args: unknown[]): void;
  abstract getStatus(): WsConnectionStatus;
  abstract onStatusChange(handler: (status: WsConnectionStatus) => void): () => void;
}
